
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexc5nqEao2LugHbEQo_45Zx6yrRwq1KBgwr05Hs_45ourqCmMMeta } from "C:/Projects/RLA/RLA_FRONT/pages/index.vue?macro=true";
import { default as index6cXQB1sCLuwcyfikWmbrMUYmD09uNAajtiNElv7Ot2kMeta } from "C:/Projects/RLA/RLA_FRONT/pages/login/index.vue?macro=true";
import { default as indexfJ4m0ZqYtjGaY522wUDBQwsKsGUWrmVfO_45zeYph9nuUMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/index.vue?macro=true";
import { default as index7sY5uegd9kIMm2tJmpoXB_4LfphSAVDIOdcYEeErJl0Meta } from "C:/Projects/RLA/RLA_FRONT/pages/reset-password/index.vue?macro=true";
import { default as indexKqkH_45NkF1JntsoB_wHT408KLUWixhKwozE3yQP7711sMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/records/index.vue?macro=true";
import { default as indexLqqLBs_cC9gn7tsYSr_hIvGpjYc3fLllRiKeImgztnEMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/reports/index.vue?macro=true";
import { default as indexbCUo78siEfYR0yvD3AEseeV6lyObPoE2xSvPyCGffQcMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/index.vue?macro=true";
import { default as index1L_CezM_nEWvxH8x_45lC7AgKM6ttR1RnzmhQG4eA_IS0Meta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/roles/index.vue?macro=true";
import { default as indexy0fYMkTprCPX74h1Oz1ef1WQGTpAE_45CFjtQEGFstnecMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/users/index.vue?macro=true";
import { default as index1lCdhEjYygKP_KZS_5zgRBIARcQK25vIgfcPEypOAO0Meta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/zones/index.vue?macro=true";
import { default as indexcNk95217RWl068XNczgaxs9RMPEB2jRD0JcThhubVEsMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/groups/index.vue?macro=true";
import { default as indexsk_45gMpmZ225n_45qKYWoOArqCioblTry42Bx1zIxI_pmIMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/records/approvals/index.vue?macro=true";
import { default as indexU_45Mf_45WLuLi4nv2DTlEJF4sP_455OLu8_YdQGckJJZ2gQsMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/approvers/index.vue?macro=true";
import { default as index0TH_45_8CrvLEyuvjlMzHmnlEZgR6WYCM4NrB2wlhH_0AMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/employees/index.vue?macro=true";
import { default as indexfj4waw8cO2z0AlklkM_457p6_AUV5qRdDbji8o6X_17pMMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/processes/index.vue?macro=true";
import { default as index2GgCZ_452YlzaanfMAtccLg1BMkszHRyhH_45XbbUH5Wlx4Meta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/activities/index.vue?macro=true";
import { default as _91id_934KGYaP4tC39YxhcfIMpBfeh22lO4O5fX6RYCAJtqJSwMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/records/activity-log/[id].vue?macro=true";
import { default as index0luaqMbn1jLlXJ9gPc2u6I3kE7nMi7RGAj8gH58CIaMMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/records/activity-log/index.vue?macro=true";
import { default as indexTJdPYqmESA8_swO36A9HhTmfen3I_0xhKbosQ670jQgMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/records/quinquennial/index.vue?macro=true";
import { default as index_45RhTLwzQ3Pnpe_Kal3XRfHbFzRYkjSkBKM85gqCXBrEMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/reports/labores-rrhh/index.vue?macro=true";
import { default as indexabidnbXum_DqIcLTRJujQH2jGULLq_x6NK85G_451aa8UMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/cost-centers/index.vue?macro=true";
import { default as indexV6MSn8qp0c_458u627p21OEqfXXz98qVEyb6za6h8_45ccYMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/subprocesses/index.vue?macro=true";
import { default as _91id_93zSDAxT6Khb1ZqZsdIka4OvTWIw9LXxFKQye0Txr_5BwMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/records/attendance-log/[id].vue?macro=true";
import { default as indexVGglXmmpLEd8QOHZuRh24BLacyleRblmi5jLkifg3HIMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/records/attendance-log/index.vue?macro=true";
import { default as index_45gUfDxPjiMYS_fPlJ1840Qd18zhE8zENwIjHj58Ft9gMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/absence-reasons/index.vue?macro=true";
import { default as indexjt7SgY13yeR85c2pQmpmQ7XyWiNCmxw1GCDAW5TavZMMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/internal-orders/index.vue?macro=true";
import { default as indexenHAsn5Bcl9pIi_45IlXUf8Fv8zXOLUtfxx9_i6qRZENQMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/reports/labores-empleados/index.vue?macro=true";
import { default as indexwIxeaHubo_8v8zHY4gBKBg7FIHdMCYGhpaAGl6rpVVgMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/reports/reporte-asistencia/index.vue?macro=true";
import { default as indexy1x_mzm3Bl44ycyyUy_TlWIJ_r3IXGVFNJIwx9l0cDcMeta } from "C:/Projects/RLA/RLA_FRONT/pages/modules/reports/consolidado-forestal/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexc5nqEao2LugHbEQo_45Zx6yrRwq1KBgwr05Hs_45ourqCmMMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: index6cXQB1sCLuwcyfikWmbrMUYmD09uNAajtiNElv7Ot2kMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/login/index.vue")
  },
  {
    name: "modules",
    path: "/modules",
    meta: indexfJ4m0ZqYtjGaY522wUDBQwsKsGUWrmVfO_45zeYph9nuUMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: index7sY5uegd9kIMm2tJmpoXB_4LfphSAVDIOdcYEeErJl0Meta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/reset-password/index.vue")
  },
  {
    name: "modules-records",
    path: "/modules/records",
    meta: indexKqkH_45NkF1JntsoB_wHT408KLUWixhKwozE3yQP7711sMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/records/index.vue")
  },
  {
    name: "modules-reports",
    path: "/modules/reports",
    meta: indexLqqLBs_cC9gn7tsYSr_hIvGpjYc3fLllRiKeImgztnEMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/reports/index.vue")
  },
  {
    name: "modules-catalogs",
    path: "/modules/catalogs",
    meta: indexbCUo78siEfYR0yvD3AEseeV6lyObPoE2xSvPyCGffQcMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/index.vue")
  },
  {
    name: "modules-catalogs-roles",
    path: "/modules/catalogs/roles",
    meta: index1L_CezM_nEWvxH8x_45lC7AgKM6ttR1RnzmhQG4eA_IS0Meta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/roles/index.vue")
  },
  {
    name: "modules-catalogs-users",
    path: "/modules/catalogs/users",
    meta: indexy0fYMkTprCPX74h1Oz1ef1WQGTpAE_45CFjtQEGFstnecMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/users/index.vue")
  },
  {
    name: "modules-catalogs-zones",
    path: "/modules/catalogs/zones",
    meta: index1lCdhEjYygKP_KZS_5zgRBIARcQK25vIgfcPEypOAO0Meta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/zones/index.vue")
  },
  {
    name: "modules-catalogs-groups",
    path: "/modules/catalogs/groups",
    meta: indexcNk95217RWl068XNczgaxs9RMPEB2jRD0JcThhubVEsMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/groups/index.vue")
  },
  {
    name: "modules-records-approvals",
    path: "/modules/records/approvals",
    meta: indexsk_45gMpmZ225n_45qKYWoOArqCioblTry42Bx1zIxI_pmIMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/records/approvals/index.vue")
  },
  {
    name: "modules-catalogs-approvers",
    path: "/modules/catalogs/approvers",
    meta: indexU_45Mf_45WLuLi4nv2DTlEJF4sP_455OLu8_YdQGckJJZ2gQsMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/approvers/index.vue")
  },
  {
    name: "modules-catalogs-employees",
    path: "/modules/catalogs/employees",
    meta: index0TH_45_8CrvLEyuvjlMzHmnlEZgR6WYCM4NrB2wlhH_0AMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/employees/index.vue")
  },
  {
    name: "modules-catalogs-processes",
    path: "/modules/catalogs/processes",
    meta: indexfj4waw8cO2z0AlklkM_457p6_AUV5qRdDbji8o6X_17pMMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/processes/index.vue")
  },
  {
    name: "modules-catalogs-activities",
    path: "/modules/catalogs/activities",
    meta: index2GgCZ_452YlzaanfMAtccLg1BMkszHRyhH_45XbbUH5Wlx4Meta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/activities/index.vue")
  },
  {
    name: "modules-records-activity-log-id",
    path: "/modules/records/activity-log/:id()",
    meta: _91id_934KGYaP4tC39YxhcfIMpBfeh22lO4O5fX6RYCAJtqJSwMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/records/activity-log/[id].vue")
  },
  {
    name: "modules-records-activity-log",
    path: "/modules/records/activity-log",
    meta: index0luaqMbn1jLlXJ9gPc2u6I3kE7nMi7RGAj8gH58CIaMMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/records/activity-log/index.vue")
  },
  {
    name: "modules-records-quinquennial",
    path: "/modules/records/quinquennial",
    meta: indexTJdPYqmESA8_swO36A9HhTmfen3I_0xhKbosQ670jQgMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/records/quinquennial/index.vue")
  },
  {
    name: "modules-reports-labores-rrhh",
    path: "/modules/reports/labores-rrhh",
    meta: index_45RhTLwzQ3Pnpe_Kal3XRfHbFzRYkjSkBKM85gqCXBrEMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/reports/labores-rrhh/index.vue")
  },
  {
    name: "modules-catalogs-cost-centers",
    path: "/modules/catalogs/cost-centers",
    meta: indexabidnbXum_DqIcLTRJujQH2jGULLq_x6NK85G_451aa8UMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/cost-centers/index.vue")
  },
  {
    name: "modules-catalogs-subprocesses",
    path: "/modules/catalogs/subprocesses",
    meta: indexV6MSn8qp0c_458u627p21OEqfXXz98qVEyb6za6h8_45ccYMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/subprocesses/index.vue")
  },
  {
    name: "modules-records-attendance-log-id",
    path: "/modules/records/attendance-log/:id()",
    meta: _91id_93zSDAxT6Khb1ZqZsdIka4OvTWIw9LXxFKQye0Txr_5BwMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/records/attendance-log/[id].vue")
  },
  {
    name: "modules-records-attendance-log",
    path: "/modules/records/attendance-log",
    meta: indexVGglXmmpLEd8QOHZuRh24BLacyleRblmi5jLkifg3HIMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/records/attendance-log/index.vue")
  },
  {
    name: "modules-catalogs-absence-reasons",
    path: "/modules/catalogs/absence-reasons",
    meta: index_45gUfDxPjiMYS_fPlJ1840Qd18zhE8zENwIjHj58Ft9gMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/absence-reasons/index.vue")
  },
  {
    name: "modules-catalogs-internal-orders",
    path: "/modules/catalogs/internal-orders",
    meta: indexjt7SgY13yeR85c2pQmpmQ7XyWiNCmxw1GCDAW5TavZMMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/catalogs/internal-orders/index.vue")
  },
  {
    name: "modules-reports-labores-empleados",
    path: "/modules/reports/labores-empleados",
    meta: indexenHAsn5Bcl9pIi_45IlXUf8Fv8zXOLUtfxx9_i6qRZENQMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/reports/labores-empleados/index.vue")
  },
  {
    name: "modules-reports-reporte-asistencia",
    path: "/modules/reports/reporte-asistencia",
    meta: indexwIxeaHubo_8v8zHY4gBKBg7FIHdMCYGhpaAGl6rpVVgMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/reports/reporte-asistencia/index.vue")
  },
  {
    name: "modules-reports-consolidado-forestal",
    path: "/modules/reports/consolidado-forestal",
    meta: indexy1x_mzm3Bl44ycyyUy_TlWIJ_r3IXGVFNJIwx9l0cDcMeta || {},
    component: () => import("C:/Projects/RLA/RLA_FRONT/pages/modules/reports/consolidado-forestal/index.vue")
  }
]